/**
 * Steps for the lp-v3 "You decide the direction, we handle the rest" section. One step is active at a
 * time: its description + feature list expand and the right-hand showcase swaps to match. Copy here is
 * PLACEHOLDER lifted/adapted from the mockups — replace with final copy. Order puts the fan-image step
 * (Context & Research, which reuses the above-footer cards) first, per the brief.
 */
export type ProductStep = {
    id: string
    title: string
    description: string
    features: string[]
    comingSoon?: boolean
}

export const PRODUCT_STEPS: ProductStep[] = [
    {
        id: 'context-research',
        title: 'Context & Research',
        description:
            'Superscale analyses thousands of ads by competitors or in your niche to detect new trends and patterns.',
        features: ['Meta Ad Library Connection', 'Shared Team Context'],
    },
    {
        id: 'creative-strategy',
        title: 'Creative Strategy',
        description:
            'Superscale turns your goals into a data-backed creative plan, mapping the angles and formats most likely to win.',
        features: ['Creative Strategy Reports', 'Automatic Concepts Generation'],
    },
    {
        id: 'statics-video',
        title: 'Statics & Video Ads Generation',
        description:
            'Your agents produce on-brand static and video ads at scale, ready to test in days instead of weeks.',
        features: ['Brand Kit Adherence', 'Batch Generation'],
    },
    {
        id: 'placements',
        title: 'Placements & Compliance',
        description:
            'Approve a creative, generate its placements and ensure compliance with AI labels, if required.',
        features: ['Safe-Zones Adherence', 'Creative Approval Process'],
    },
    {
        id: 'launch',
        title: 'Launch & Scheduling',
        description:
            'Schedule and launch campaigns straight to Meta ads or Google ads - no manual exports, no busywork.',
        features: ['Direct Channel Publishing', 'Approval Workflows'],
        comingSoon: true,
    },
    {
        id: 'analysis',
        title: 'Analysis',
        description:
            'Superscale reads performance from your ad accounts back into the loop, learning what works to sharpen the next batch.',
        features: ['Creative Analytics', 'Auto Iteration'],
    },
]
